module.exports = __webpack_public_path__ + "img/warningiconorange.e1bfc4bd.svg";